import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import FeedbackButton from './FeedbackButton';
import ScrollToTop from './ScrollToTop';
import SponsoredAdBanner from './SponsoredAdBanner';

export default function Layout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <SponsoredAdBanner />
      <Footer />
      <FeedbackButton />
    </div>
  );
}